import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dialog, DialogTitle, DialogContent, Button, IconButton } from '@material-ui/core';
import LoadingIcon from '../Common/LoadingIcon';
import { Translate } from '../../localization';

class Referral extends Component {
    userRefCode;

    copyCodeToClipboard = () => {
        this.userRefCode.select()
        document.execCommand("copy")
    }

    render() {
        const {userData:{referral_code, bonus_threshold, referral_reward_amount}} = this.props;
        // creating referral link for the user for the specific domain
        const refLink = ``;
        return (
            <Dialog onClose={this.props.hideReferral} aria-labelledby="change-password-dialog-title" open={true} className="auth__modal referral-center" scroll="body">
                <DialogTitle id="change-password-dialog-title" disableTypography>
                    <h3 className="m-0 fs-17">{Translate.refHeading}</h3>
                    <IconButton aria-label="close" className="close-modal" onClick={this.props.hideReferral}>
                        <i className="material-icons icon-white fs-22"> close </i>
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <div className="ref-div" id="v-pills-authentication" role="tabpanel" aria-labelledby="v-pills-authentication-tab"> 
                        <div className="referralUsername first-method">
                            {/* <p>{Translate.refText1}</p>
                            <p>
                                {Translate.refText2}
                                {referral_reward_amount}
                                {Translate.refText3}
                                
                            </p> */}

                            <div className="copy-address">
                                <input readOnly="readonly" value= {refLink} ref={el => (this.userRefCode = el)} />
                                <div className="copy-icon">
                                    <img onClick={this.copyCodeToClipboard} className='pointer-cursor' src="/images/copy-icon.png" />
                                </div>
                            </div>
                            <div className="copy-btn">
                                <a id="add-factor" onClick={this.copyCodeToClipboard}>{Translate.refCopyText}</a>
                            </div>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userData: state.user.data,
        language: state.general.language,
    };
};

export default connect(mapStateToProps, null)(Referral);